import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import DateSlot from '@components/DataGrid/DateSlot';
import RenderCell from '@components/DataGrid/RenderCell';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const headerDisplayName = 'Doc Date';

const jobDateDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'ENT',
	minWidth: 120,
	width: 120,
	headerName: 'ENT',
	headerDisplayName,
	renderHeader: () => <RenderHeader primaryText={headerDisplayName} />,
	renderCell: ({ row }) => <RenderCell primarySlot={<DateSlot toDate={row.jobDate} />} />,
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { jobDate } = row;
				return caseInsensitiveIncludes(value, jobDate);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.jobDate?.date ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default jobDateDefinition;
